import React, { useRef, useState, useEffect } from "react"
import { graphql, useStaticQuery, Link } from "gatsby"
import { Index } from "elasticlunr"
import tw from "twin.macro"
//import { GrFormClose } from "react-icons/gr"

const SearchContainer = tw.div`lg:inline-block w-full lg:w-56`
const SearchResults = tw.div`border border-gray-300 rounded-b shadow absolute z-50 bg-white max-w-sm`
const SearchMessage = tw.div`p-2 text-sm`
const SearchResult = tw(Link)`hover:bg-gray-100 block p-2 text-sm`
const SearchLabel = tw.label`sr-only`
const SearchInput = tw.input`w-full bg-transparent text-sm p-2 flex-1 focus:bg-white rounded-l-full border border-transparent focus:border-gray-300 outline-none`
const SearchInputWrapper = tw.div`shadow-inner rounded-full w-full bg-gray-300 flex items-center`
const SearchClear = tw.span`text-gray-700 m-2 transition ease-in-out duration-300 cursor-pointer`

const SearchPage = () => {
  const data = useStaticQuery(graphql`
    query SearchIndexQuery {
      siteSearchIndex {
        index
      }
    }
  `)
  const [query, setQuery] = useState("")
  const [results, setResults] = useState([])
  const [index] = useState(Index.load(data.siteSearchIndex.index))
  const [displayResults, setDisplayResults] = useState(false)

  const wrapperRef = useRef(null)

  const handleQueryFocus = () => {
    setDisplayResults(true)
  }

  const handleQueryChange = e => {
    const q = e.target.value
    setQuery(q)
    setDisplayResults(true)
    setResults(
      index
        .search(q, { expand: true })
        .map(({ ref }) => index.documentStore.getDoc(ref))
    )
  }

  useEffect(() => {
    const handleClickOutside = e => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setDisplayResults(false)
      }
    }
    document.addEventListener("mousedown", handleClickOutside)
    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [])

  return (
    <SearchContainer ref={wrapperRef}>
      <SearchLabel htmlFor="search">Search:</SearchLabel>
      <SearchInputWrapper>
        <SearchInput
          id="search"
          placeholder="Search"
          onChange={handleQueryChange}
          onFocus={handleQueryFocus}
          value={query}
        />
        <SearchClear style={query != '' ? tw`opacity-100` : tw`opacity-0`} onClick={() => setQuery("")} >&times;</SearchClear>
      </SearchInputWrapper>
      {displayResults && !!query && (
        <SearchResults>
          {results.length > 0 ? (
            results.map(page => (
              <SearchResult to={page.path} key={page.id}>
                {page.title}
              </SearchResult>
            ))
          ) : (
            <SearchMessage>No results found</SearchMessage>
          )}
        </SearchResults>
      )}
    </SearchContainer>
  )
}

export default SearchPage
